/* globals Waveform */

import ko from "knockout";
import _ from "lodash";
import "lib/waveform"; // adds Waveform to the window TODO: make this a proper module

/**
 * Binding handler that renders a waveform from sound amplitude data
 * @param {Object[]} options.data - Array of Numbers describing amplitude, between 0 and 1
 *
 * # Optional Arguments
 * @param {String} [options.innerColor='transparent'] A string indicating inner color to user for the waveform
 * @param {String} [options.outerColor='#fff'] A string indicating outer color to user for the waveform
 *
 * Sample usage: waveform: {
 *                   data: [],
 *                   innerColor: '#333',
 *                   outerColor: 'transparent'
 *               }
 *
 */
ko.bindingHandlers.waveform = {
    init: function (element, valueAccessor) {
        const waveformOptions = {
            canvas: element,
            data: [], // This will get filled in at update
            innerColor: valueAccessor().innerColor || "transparent",
            outerColor: valueAccessor().outerColor || "#ffffff",
            interpolate: true,
        };

        // This draws on the canvas as a side effect.
        const waveform = new Waveform(waveformOptions);
        ko.utils.domData.set(element, "waveform", waveform);

        // Cleanup
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            ko.utils.domData.clear(element, "waveform");
        });
    },
    update: function (element, valueAccessor) {
        const waveform = ko.utils.domData.get(element, "waveform");

        if (waveform) {
            const mappedData = _.map(
                ko.unwrap(valueAccessor().data),
                function (value) {
                    return Math.abs(value - 0.5) * 4 + 0.01;
                }
            );

            const participantType = ko.unwrap(valueAccessor().participantType);
            const numChannels = ko.unwrap(valueAccessor().numChannels);

            waveform.width = mappedData.length;
            waveform.context.canvas.width = mappedData.length;

            waveform.update({
                data: mappedData,
            });

            if (numChannels == 2) {
                if (participantType) {
                    //erase the top half of the external waveform
                    waveform.context.clearRect(
                        0,
                        0,
                        waveform.width,
                        waveform.height / 2
                    );
                } else {
                    //erase the bottom half of the internal waveform
                    waveform.context.clearRect(
                        0,
                        waveform.height / 2,
                        waveform.width,
                        waveform.height / 2
                    );
                }
            }
        }
    },
};
